<div class="ppl-container-body">
  <div class="ppl-container">
    <div class="ppl-content-container" style="padding: 8px; max-height: calc(100vh - 140px); box-sizing: border-box;">
      <div class="line1">
        <div class="action">
          <ppl-button [label]="'Back'" icon="fa fa-chevron-left" (click)="goBack()"
            [customClass]="'primary-button semi-rounded'" [iconPosition]="'left'"></ppl-button>
        </div>
      </div>
      <div class="line2">
        {{pageTitle}}
      </div>
      <div style="width: 100%">
        <ppl-accordion [title]="'Basic Information'" [isOpen]="true">
          <div class="wiz-body">
            <div class="ppl-mt24">
              @if((mode==="edit") && !this.isNew && !isReadOnly){
              <div class="custom-row">
                <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
                  (click)="onCancel()"></ppl-button>
                <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
                  (click)="onUpdate()"></ppl-button>
              </div>
              }
              @if(mode==="read" && !this.isNew && !isReadOnly){
              <div class="custom-row">
                <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'" [iconPosition]="'left'"
                  (click)="onEdit()"></ppl-button>
              </div>
              }
              @if(mode==="edit"){
              <form nz-form [formGroup]="participantProviderRates" class="row ppl-p0">
                @if(isAttrAvailable('code')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="code"
                      class="ppl-form-label">{{getAttributes('code').label}}
                      @if(getAttributes('code').mandatory === 'Y'){
                      <span>*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('code')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['code'] }">
                          <ppl-dropdown-select formControlName="serviceCodeDetailId" id="servicecodeDetailId"
                            class="ppl-select" [options]="serviceCodes" [optionLabel]="'code'"
                            [optionValue]="'serviceCodeDetailId'" [placeholder]="'Select Service Code'">
                          </ppl-dropdown-select>
                        </div>
                      </div>
                      @if (validationErrors['serviceCodeDetailId']) {
                      <span class="pl-1 error-message">{{validationErrors['serviceCodeDetailId']}}</span>
                      }
                      <div
                        *ngIf="participantProviderRates.get('serviceCodeDetailId')?.errors?.['required'] && participantProviderRates.get('serviceCodeDetailId')?.touched"
                        class="pl-1 error-message">
                        Service Code is required
                      </div>
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }
                @if(isAttrAvailable('region')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item">
                  <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="region" class="ppl-form-label">Regional Center
                      @if(getAttributes('region').mandatory === 'Y'){
                      <span>*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="'Regional Center'" nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['region'] }">
                          <ppl-dropdown-select formControlName="orgId" id="orgId" class="ppl-select"
                            [options]="regionalCenters" [optionLabel]="'org_name'" [optionValue]="'orgid'">
                          </ppl-dropdown-select>
                        </div>
                      </div>
                      @if (validationErrors['region']) {
                      <span class="pl-1 error-message">{{validationErrors['region']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }
                @if(isAttrAvailable('fromdate')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="fromdate"
                      class="ppl-form-label">{{getAttributes('fromdate').label}}
                      @if(getAttributes('fromdate').mandatory === 'Y'){
                      <span>*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('fromdate')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <ppl-date-picker formControlName="fromDate" [id]="'fromDate'" [showIcon]="true"
                          dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
                          [panelStyleClass]="'custom-calendar-panel'" [placeholder]="getAttributes('fromdate').placeholder"
                          [styleClass]="validationErrors['fromDate'] ? 'error' : ''">
                        </ppl-date-picker>
                      </div>
                      @if (validationErrors['fromdate']) {
                      <span class="pl-1 error-message">{{validationErrors['fromdate']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }
                @if(isAttrAvailable('todate')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label nzFor="todate" [nzSm]="10" [nzXs]="24"
                      class="ppl-form-label">{{getAttributes('todate').label}}
                      @if(getAttributes('todate').mandatory === 'Y'){
                      <span>*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('todate')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <ppl-date-picker formControlName="toDate" [id]="'toDate'" [showIcon]="true"
                          dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'" inputId="icondisplay"
                          [panelStyleClass]="'custom-calendar-panel'"
                          [placeholder]="getAttributes('todate').placeholder"
                          [styleClass]="validationErrors['toDate'] ? 'error' : ''">
                        </ppl-date-picker>
                      </div>
                      @if (validationErrors['todate']) {
                      <span class="pl-1 error-message">{{validationErrors['todate']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }
                @if(isAttrAvailable('rate')){
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label nzFor="rate" [nzSm]="10" [nzXs]="24"
                      class="ppl-form-label">{{getAttributes('rate').label}}
                      @if(getAttributes('rate').mandatory === 'Y'){
                      <span>*</span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('rate')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="rate" id="rate"
                          placeholder="{{getAttributes('rate').placeholder}}"
                          [ngClass]="{'error': validationErrors['rate'] }" />
                      </div>
                      @if (validationErrors['rate']) {
                      <span class="pl-1 error-message">{{validationErrors['rate']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                }
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item">
                  <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="state" class="ppl-form-label">State
                      <span>*</span>
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="'State'" nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['stateName'] }">
                          <ppl-dropdown-select formControlName="stateName" id="state" [options]="states"
                            [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueName'">
                          </ppl-dropdown-select>
                        </div>
                      </div>
                      @if (validationErrors['stateName']) {
                      <span class="pl-1 error-message">{{validationErrors['stateName']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item">
                  <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="county"
                      class="ppl-form-label">{{getAttributes('county').label}}
                      @if(getAttributes('county').mandatory === 'Y'){
                      <span></span>
                      }
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="getAttributes('county')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['county'] }">
                          <ppl-dropdown-select formControlName="countyName" id="countyId" class="ppl-select"
                            [options]="counties" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueName'">
                          </ppl-dropdown-select>
                        </div>
                      </div>
                      @if (validationErrors['county']) {
                      <span class="pl-1 error-message">{{validationErrors['county']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
                <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                  <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="cityName" class="ppl-form-label">City
                      <span></span>
                    </nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                      <div nz-tooltip [nzTooltipTitle]="'City'" nzTooltipPlacement="topRight">
                        <ppl-dropdown-select formControlName="cityName" id="cityName" class="ppl-select"
                          [options]="cities" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueName'">
                        </ppl-dropdown-select>
                      </div>
                      @if (validationErrors['cityName']) {
                      <span class="pl-1 error-message">{{validationErrors['cityName']}}</span>
                      }
                    </nz-form-control>
                  </nz-row>
                </nz-form-item>
              </form>

              @if(isNew){
              <div class="custom-row">
                <ppl-button [label]="'Cancel'" [icon]="'fa fa-close'" [styleString]="'margin-right:4px; font-size:0.857rem;'"
                  [customClass]="'ghost-button'" [iconPosition]="'right'" (click)="goBack()"></ppl-button>
                <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'primary-button'"
                  [iconPosition]="'right'" (click)="onAdd()"></ppl-button>
              </div>
              }
              }
              @else if (mode==="read") {
              <div nz-row>
                @if(isAttrAvailable('region')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      Regional Center
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.orgName }}</div>
                  </div>
                </div>
                }

                @if(isAttrAvailable('code')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("code").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.serviceCode }}</div>
                  </div>
                </div>
                }

                @if(isAttrAvailable('fromdate')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("fromdate").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.fromDate }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('todate')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("todate").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.toDate }}</div>
                  </div>
                </div>
                }
                @if(isAttrAvailable('rate')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("rate").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">
                      <i style="text-align: center;font-weight: 700;font-size:small" [class]="'pi pi-dollar'"></i>
                      {{ savedData?.rate }}
                    </div>
                  </div>
                </div>
                }
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      State
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.stateName }}</div>
                  </div>
                </div>
                @if(isAttrAvailable('county')){
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      {{ getAttributes("county").label }}
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.countyName }}</div>
                  </div>
                </div>
                }
                <div nz-col nzSpan="12">
                  <div nz-row>
                    <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                      City
                    </div>
                    <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.cityName }}</div>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </ppl-accordion>
      </div>
    </div>
  </div>
</div>